import { render } from "./addNewPrice.vue?vue&type=template&id=1871bd33&ts=true"
import script from "./addNewPrice.vue?vue&type=script&lang=ts"
export * from "./addNewPrice.vue?vue&type=script&lang=ts"

import "./addNewPrice.vue?vue&type=style&index=0&id=1871bd33&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__